// extracted by mini-css-extract-plugin
export default {"cardBox":"bookingCards_cardBox__W1M-d","customCard":"bookingCards_customCard__QFpYG","imageBox":"bookingCards_imageBox__L3Kx5","textBox":"bookingCards_textBox__MYynM"};